import React, { useState, useRef } from 'react';
import { UserX } from 'lucide-react';

const FloatingSpeedDial = ({ onStop }) => {
  const [position, setPosition] = useState({ x: window.innerWidth - 80, y: window.innerHeight - 80 });
  const [isDragging, setIsDragging] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const dragStartPos = useRef(null);

  const handlePointerDown = (e) => {
    setIsDragging(true);
    dragStartPos.current = { x: e.clientX, y: e.clientY, posX: position.x, posY: position.y };
    e.target.setPointerCapture(e.pointerId);
  };

  const handlePointerMove = (e) => {
    if (isDragging) {
      setPosition({
        x: dragStartPos.current.posX + (e.clientX - dragStartPos.current.x),
        y: dragStartPos.current.posY + (e.clientY - dragStartPos.current.y)
      });
    }
  };

  const handlePointerUp = (e) => {
    setIsDragging(false);
    e.target.releasePointerCapture(e.pointerId);
    
    if (dragStartPos.current) {
      const dx = e.clientX - dragStartPos.current.x;
      const dy = e.clientY - dragStartPos.current.y;
      if (Math.abs(dx) < 5 && Math.abs(dy) < 5) {
        onStop();
      }
    }
  };

  return (
    <div
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'fixed',
        left: Math.max(0, Math.min(position.x, window.innerWidth - (isHovered ? 180 : 60))),
        top: Math.max(0, Math.min(position.y, window.innerHeight - 60)),
        zIndex: 9999,
        backgroundColor: 'rgba(255, 77, 79, 0.95)',
        backdropFilter: 'blur(8px)',
        color: 'white',
        borderRadius: '30px',
        width: isHovered ? '200px' : '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: isHovered ? '0 8px 24px rgba(255, 77, 79, 0.4)' : '0 4px 12px rgba(0,0,0,0.2)',
        cursor: isDragging ? 'grabbing' : 'pointer',
        transition: isDragging ? 'none' : 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        userSelect: 'none',
        touchAction: 'none',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        overflow: 'hidden',
        padding: '0 15px',
        gap: '10px'
      }}
      title="Stop Impersonating"
    >
      <UserX size={24} color="white" style={{ flexShrink: 0 }} />
      <span 
        style={{ 
          fontSize: '14px', 
          fontWeight: '600', 
          whiteSpace: 'nowrap',
          opacity: isHovered ? 1 : 0,
          width: isHovered ? 'auto' : 0,
          transform: isHovered ? 'translateX(0)' : 'translateX(-10px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          pointerEvents: 'none'
        }}
      >
        Stop Impersonating
      </span>
    </div>
  );
};

export default FloatingSpeedDial;
